import { render, staticRenderFns } from "./newsSetting.vue?vue&type=template&id=759e42b6&scoped=true&"
import script from "./newsSetting.vue?vue&type=script&lang=js&"
export * from "./newsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759e42b6",
  null
  
)

export default component.exports